import React from "react";
import GameListSwitcherContainer from "../GamesMenu/GameListSwitcherContainer";

class E404Page extends React.PureComponent {

    render() {
        return <div className="rankings">
            <GameListSwitcherContainer/>
            <div className="alert alert-error">Page not found</div>
        </div>;
    }
}


export default E404Page